/** Template checklist default per kode kategori IT */
export const CHECKLIST_BY_KODE = {
  INTERNET: [
    { item: "Kecepatan sesuai paket", status: null, nilai: "" },
    { item: "Latency / ping normal", status: null, nilai: "" },
    { item: "Koneksi stabil (tanpa drop)", status: null, nilai: "" },
  ],
  CCTV: [
    { item: "Gambar jernih", status: null, nilai: "" },
    { item: "Rekaman tersimpan", status: null, nilai: "" },
    { item: "Sudut kamera sesuai", status: null, nilai: "" },
  ],
  SERVER: [
    { item: "Suhu / pendinginan normal", status: null, nilai: "" },
    { item: "Service utama running", status: null, nilai: "" },
    { item: "Backup terjadwal OK", status: null, nilai: "" },
  ],
  WIFI: [
    { item: "SSID terlihat", status: null, nilai: "" },
    { item: "Signal strength memadai", status: null, nilai: "" },
    { item: "Autentikasi berfungsi", status: null, nilai: "" },
  ],
};

export const DEFAULT_CHECKLIST = [
  { item: "Kondisi fisik / visual OK", status: null, nilai: "" },
  { item: "Fungsi utama berjalan", status: null, nilai: "" },
  { item: "Tidak ada keluhan user", status: null, nilai: "" },
];

export function getChecklistTemplate(kode) {
  if (!kode) return DEFAULT_CHECKLIST.map((c) => ({ ...c }));
  const key = String(kode).toUpperCase();
  const tpl = CHECKLIST_BY_KODE[key] || DEFAULT_CHECKLIST;
  return tpl.map((c) => ({ ...c }));
}
